/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
import {
  Component, OnInit, OnDestroy, ViewChild, ViewEncapsulation, QueryList, ViewChildren,
  ElementRef, TemplateRef, ChangeDetectorRef, isDevMode, ChangeDetectionStrategy, AfterViewInit, HostListener
} from '@angular/core';
import { ImageService } from '../services/image.service';
import { ImageFile } from '../models/imageFile';
import { StarbaseNotificationService, StarbaseNotificationSentiment, StarbaseNotificationObject } from 'starbase-notification';
import { StarbaseLoginService, IUserTokenModel } from 'starbase-login';
import { Observable, Subscription, of, merge, Subject, from, throwError } from 'rxjs';
import { ImageType, ImageTypes } from '../models/imageType';
import { debounceTime, distinctUntilChanged, switchMap, takeUntil, mergeMap, catchError, finalize, delay, filter, share, map, startWith } from 'rxjs/operators';
import { DEFAULT_RPP_SETTING, GalleryTypeService } from '../services/gallery-type.service';
import { LookupDataService } from '../services/lookup-data.service';
import { TypeaheadResults } from '../models/typeaheadResults';
import { FilterParams, IHasUID, TrackByUID } from 'starbase-launcher';
import { galleryAnimationFade, galleryAnimationStagger } from '../animations';
import { WriteOrdinalSuffixOfNumber } from 'starbase-launcher';
import { ThumbnailComponent } from '../thumbnail/thumbnail.component';
import { libraryViewModes } from '../libraryViewModes';
import { SelectContainerComponent } from 'ngx-drag-to-select';
import { StarbaseModalOptions, StarbaseModalTypes, StarbaseModalDialogService, StarbaseModalButton } from 'starbase-modal-dialog';
import { RelatedSetLinkingModel } from '../models/relatedSetLinkingModel';
import { environment } from 'src/environments/environment.prod';
import { BoundImageSet } from '../models/boundImageSet';
import { ActivatedRoute, Router } from '@angular/router';
import { LibraryFilterComponent } from '../library-filter/library-filter.component';
import { AppInsightsService } from '../app-insights.service';
import { LibrarySearchComponent } from '../library-search/library-search.component';
import { IFilterEventData } from '../sidebar-filter/sidebar-filter.component';
import { NgbTypeaheadSelectItemEvent, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { StarbaseModalOverlayService } from 'modal-overlay';
import { LibSelectConfig, GatewayLibSelects } from '../lib-select-button/lib-select-button.component';
import { ThisReceiver } from '@angular/compiler';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { RelatedImageSetViewDataModel } from '../models/relatedImageSetViewDataModel';
import { BreakpointService } from '../breakpoint.service';
import { BatchEdit } from '../models/batchEdit';
import { SelectionModel } from '@angular/cdk/collections';
import { LassoSelectDirective, LassoSelectionEvent } from '../directives/lasso-select.directive';
import { RelatedSetModel, RelatedSetTypeEnum } from '../models/relatedSetModel';
import { FormControl } from '@angular/forms';
import { ThumbnailType } from '../models/thumbnailType';


const LOADING_MESSAGE = 'Loading…';
const SHOWMORE_TEXT = 'Show more';

const STAGGER_ANIM_TIME = 750; // ms

type LibCount = {
  val: number;
  txt: string;
  count: number;
  selected: boolean;
};

/** This is the main gallery screen component for the app. */
@Component({
  selector: 'app-library',
  templateUrl: './library.component.html',
  styleUrls: ['./library.component.css', '../sidebar-filter/sidebar-filter.component.css']
  ,
  animations: [galleryAnimationFade, galleryAnimationStagger,
      trigger('fadeInOut', [
      state('void', style({ opacity: 0 })),
      transition(':enter, :leave', [animate(500)])
    ])
  ]
  ,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
// AKA 'Gallery'
export class LibraryComponent implements OnInit, AfterViewInit, OnDestroy {
  // @ViewChildren(ThumbnailComponent, { read: ElementRef }) thumbnailDomElements: QueryList<ThumbnailComponent>[];
  @ViewChildren(ThumbnailComponent) thumbnails: ThumbnailComponent[];
  @ViewChildren('.thumbnailContainer') thumbnailsCss: QueryList<ElementRef>;
  @ViewChild('selectionContainer', { static: true }) selectionComponent: SelectContainerComponent;
  @ViewChild('selectHelpTextModal', { static: true }) selectModeTextModal: TemplateRef<any>;
  @ViewChild('relateImageSetsModal', { static: true }) relateImageSetsModal: TemplateRef<any>;
  @ViewChild('bindImageSetsModal', { static: true }) bindImageSetsModal: TemplateRef<any>;
  @ViewChild('relatedSetsSearcher') relatedSetsSearcher: NgbTypeahead;
  // @ViewChild('txtBoundImageSetName', { static: false }) txtBoundImageSetName: ElementRef;
  @ViewChild('mainLibraryFilter', { static: true }) mainLibraryFilter: LibraryFilterComponent;
  // @ViewChild('mainLibraryControls', { static: true }) mainLibraryControls: ElementRef;
  // @ViewChild('quickSearch', { static: true }) quickSearch;
  @ViewChild('libraryMainSearch', { static: true }) libMainSearch: LibrarySearchComponent;
  @ViewChildren(ThumbnailComponent) thumbnailsVisible: QueryList<ThumbnailComponent>;
  @ViewChild('confirmFilterModal', { static: true }) confirmFilterModal: TemplateRef<any>;
  @ViewChild(LassoSelectDirective) lassoDirective: LassoSelectDirective;
  ThumbnailType = ThumbnailType;
  public Math = Math;

  private currentFilters: FilterParams<ImageFile>;
  private defaultImgType = new ImageType();

  // eslint-disable-next-line @typescript-eslint/naming-convention
  public LOADING_MESSAGE: string = LOADING_MESSAGE; // import constant for template use
  // if false, the Batch Edit button will be disabled.
  // This was added at Patty's request due to no trust in the Batch Edit functionality or the end users of this functionality.
  public allowBatchEdit = true;

  public libImages: ImageFile[] = []; // main data array
  public libSearch$: Observable<TypeaheadResults>; // for search box
  librarySearchEntities: string[];
  public isAdmin: boolean;
  public loggedInUser: IUserTokenModel = null;
  public showUploader = false; // display component toggler
  ignoreTypeaheadSuggestion: boolean;
  relatedSetsSearcherOutput: string;
  otherLibCounts: LibCount[] = [];
  public messageColor = 'black';
  public loadMoreText: string = SHOWMORE_TEXT;
  public recordCount = '';
  public retry: boolean; // set to true if user can trigger a reload after an error
  // public years: { year: string, selected: boolean }[] = [];

  relatedSetControl = new FormControl();
  filteredRelatedSets: Observable<RelatedSetModel[]>;

  public thumbnailGridMode = libraryViewModes.listMode;
  public maxFileSize: number;

  public scrollThumbs = true;

  dropdownOpened = false;
  tempBoundSetName = '';

  mainLibraryControlsWidth$: Observable<number>; // px value of CSS

  public imageTypeFilter: ImageType = new ImageType();
  public prePrintedTypes: ImageType[] = [];
  // public allImageTypes: string[];
  public allImageTypesVirtual = ImageType.imageTypes;
  presentImageTypes: { val: number; txt: string; selected: boolean }[] = []; // for Civ Research

  public lastViewedRecord: ImageFile = new ImageFile();

  relatedSetTypeFocus$ = new Subject<string>();
  relatedSetTypeClick$ = new Subject<string>();

  typeaheadLimit = 5;

  public rpp = DEFAULT_RPP_SETTING; // default results per page for filterParams
  /** A collection of the ImageFile objects selected for this batch operation. */
  batchEditImages: ImageFile[] = [];
  lastSelectedImage: ImageFile | null = null;

  selection = new SelectionModel<ImageFile>(true, []); // true = allows multi-select

  private mouseDownPoint: { x: number, y: number } | null = null;
  private readonly DRAG_THRESHOLD = 5; // pixels
  trackByUID = TrackByUID;
  ordinalSuffix = WriteOrdinalSuffixOfNumber;
  isHandset = false;
  private _subscription;

  public batchEditMode = false; // AKA Select Images Mode
  public selectionMode = false; // Controls the drag-a-box selection system
  public updateSeqMode = false; // Update the sequence order of a specific related image set's images
  lastSelectAll = false;
  showFilters = this.isHandset ? false : true;
  showBatchEditBox = false;
  currentSort = 2;
  sortChanged = false;

  selectedThumbnails: [any];

  selectModeModal: StarbaseModalOptions;
  createImageSetModal: StarbaseModalOptions;
  createBoundSetModal: StarbaseModalOptions;
  // relatedSetsForBatch: RelatedSetModel[] = [];
  allRelatedImageSets: RelatedSetLinkingModel[] = [];

  selectedRelatedSetName: string;
  selectedRelatedSetUID: number;
  allRelatedSets: RelatedSetModel[] = []; // Store all relatedSetModels
  relatedSetsSearcherOutputUID: number; // store selected UID
  selectedImageSetUIDDropdown: number;
  
  relatedImageSetsForBatch: RelatedSetModel[] = [];
  relatedSetDescription = '';
  relatedSetType: RelatedSetTypeEnum = RelatedSetTypeEnum.GENERAL;
  isOrdnanceReturnSet = false;
  duplicateNameConfirmModal: StarbaseModalOptions;
  pendingRelatedSetName = '';
  // private isRelatingImagesModalOpen = false;

  civilianMode = false;
  prePrintedMode = false;

  addingToBoundSetMode = false;
  lastSearchString = '';
  reset: boolean;
  maintainLibrary = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RSVcontainer = false;
  showPrePrintedList = false;
  showCivResearchList=  false;
  showRSthumbnails = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RISSearchResults: RelatedImageSetViewDataModel[] = [];
  loadMoreRSButton = false;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RISSearchResultsToDisplay: RelatedImageSetViewDataModel[] = [];
  // eslint-disable-next-line @typescript-eslint/naming-convention
  RISSearchLoadMoreClickedCount = 1;
  keepRSThumbnailsHidden = false;
  originalLibImages = [];
  currentSeqNumbersModified = false;
  isSavingUpdatedSequence = false;
  isSaving = false;
  relatedImageSets: RelatedImageSetViewDataModel[] = [];
  relatedImageModels: ImageFile[] = [];

  public showLedgerSetsView = false;
  public libraryLedgerSets: RelatedImageSetViewDataModel[] = [];
  public currentViewTitle = 'Library';

  private imageSubscription: Subscription;
  private imageFilteredSubscription: Subscription;
  private imageTypeFilterSubscription: Subscription;
  private relatedImageSubscription: Subscription;
  private relatedImageSetNameSubscription: Subscription;
  private boundImageSetSubscription: Subscription;

  private subscriptionList: Subscription[] = [];
  private filterCancel$ = new Subject<void>();
  private _message: string;
  isLoading: boolean;

  constructor(private imgSvc: ImageService,
    private loginSvc: StarbaseLoginService,
    private notiSvc: StarbaseNotificationService,
    public modalSvc: StarbaseModalDialogService,
    private galleryTypeSvc: GalleryTypeService,
    private lookupSvc: LookupDataService,
    private router: Router,
    private appInsightsSvc: AppInsightsService,
    private cd: ChangeDetectorRef,
    private overlaySvc: StarbaseModalOverlayService,
    private breakpointService: BreakpointService,
    private route: ActivatedRoute) {
      this.maxFileSize = this.imgSvc.imageMaxSize;
      this.rpp = this.galleryTypeSvc.getLastResultsPerPageSetting(this.rpp);
      this.defaultImgType.typeOfImage = '';
      this.defaultImgType.uid = 0;
      // const itk = Object.keys(ImageTypes);
      // this.allImageTypes = itk.slice(itk.length / 2);

      const library = this.route.snapshot.paramMap.get('library');
      if (library) {
        switch (library) {
          case 'Clothing_Ledger':
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.ClothingLedgerBooksLibSelect.imageType);
            break;
          case GatewayLibSelects.GSOrdersLibSelect.imageType.typeOfImage:
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.GSOrdersLibSelect.imageType);
            break;
          case 'Letters':
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.LettersLibSelect.imageType);
            break;
          case 'Forms':
            this.galleryTypeSvc.setPrePrintedMode(true);
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.MilitaryFormsLibSelect.imageType);
            break;
          case GatewayLibSelects.MorningReportsLibSelect.imageType.typeOfImage:
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.MorningReportsLibSelect.imageType);
            break;
          case GatewayLibSelects.MusterRollsLibSelect.imageType.typeOfImage:
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.MusterRollsLibSelect.imageType);
            break;
          case GatewayLibSelects.OrdnanceReturnsLibSelect.imageType.typeOfImage:
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.OrdnanceReturnsLibSelect.imageType);
            break;
          case GatewayLibSelects.PhotosLibSelect.imageType.typeOfImage:
            this.galleryTypeSvc.setGalleryType(GatewayLibSelects.PhotosLibSelect.imageType);
            break;
          case 'Civilian':
            this.galleryTypeSvc.CivilianResearchMode = true;
            break;
        }
      }
      
    this.relatedImageModels = this.galleryTypeSvc.getLibraryRelatedSetImages(this.currentFilters?.rpp);
    if (!this.router.navigated) {
      this.galleryTypeSvc.getCurrentLibraryFilters(null, true);
      setTimeout(() => this.galleryTypeSvc.reloadComplete(), 15000);
    }
  }

  public get message(): string {
    return this._message;
  }

  get searchTerm() {
    return this.lastSearchString || this.keywordFilterActive;
  }

  get prePrintedTypesSelected(): ImageType[] {
    return this.prePrintedTypes.filter(t => t.selected);
  }
  get civilianTypesSelectedCount(): number {
    return this.otherLibCounts.filter(t => t.selected).length;
  }
  get keywordFilterActive(): string {
    return this.galleryTypeSvc.getKeywordFilter() || '';
  }

  // get relatedSetUIDFilterActiveBool(): boolean {
  //   const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
  //   return cf.filters.some(f => f[0] === 'RelatedSetUID');
  // }
  get relatedSetUIDFilterActiveBool(): boolean {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
    return cf.filters.some(f => f[0] === 'RelatedSetUID');
  }

  // get relatedSetNameFilterActiveName(): string {
  //   const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
  //   const matchedFilter = cf.filters.filter((f: any[]) => f[0] === 'RelatedImageSet');

  //   if (matchedFilter.length > 0 && matchedFilter[0].length > 1) {
  //     return matchedFilter[0][1] as string;
  //   }
  //   return '';
  // }

  get relatedSetNameFilterActiveUID(): number {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
    const matchedFilter = cf.filters.find((f: any[]) => f[0] === 'RelatedSetUID');
    
    if (matchedFilter && matchedFilter.length > 1) {
      return parseInt(matchedFilter[1], 10);
    }
    return 0;
  }

  get relatedSetNameFilterActiveName(): string {
    const uid = this.relatedSetNameFilterActiveUID;
    if (uid && this.allRelatedSets && this.allRelatedSets.length > 0) {
      const foundSet = this.allRelatedSets.find(s => s.uid === uid);
      return foundSet ? foundSet.name : '';
    }
    return '';
  }

  resultFormatter = (result: RelatedSetModel) => {
    if (!result) return '';
    return result.name;
  };

  inputFormatter = (value: any) => {
    if (!value) return '';
    if (typeof value === 'string') return value;
    return value?.name || '';
  };

  onExistingSetSelected(event: any): void {
    const selectedValue = event.target.value;
    console.log('Dropdown selection changed:', selectedValue);
    
    if (!selectedValue || selectedValue === '') {
      // User selected "Choose from dropdown" - reset to typeahead mode
      this.selectedImageSetUIDDropdown = null;
      this.relatedSetsSearcherOutput = '';
      this.relatedSetsSearcherOutputUID = null;
      
      // Enable the FormControl
      this.relatedSetControl.enable();
      this.relatedSetControl.setValue('');
    } else {
      // User selected an existing set from dropdown
      const selectedUID = parseInt(selectedValue, 10);
      this.selectedImageSetUIDDropdown = selectedUID;
      
      const selectedSet = this.relatedImageSetsForBatch.find(s => s.uid === selectedUID);
      if (selectedSet) {
        this.relatedSetsSearcherOutput = selectedSet.name;
        this.relatedSetsSearcherOutputUID = selectedUID;
        
        // Disable the FormControl and set the value
        this.relatedSetControl.setValue(selectedSet.name);
        this.relatedSetControl.disable();
      }
    }
    
    this.cd.markForCheck();
  }


  removeRelatedSetFilter() {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
    cf.filters = cf.filters.filter((f: any[]) => f[0] !== 'RelatedSetUID');
    this.galleryTypeSvc.setCurrentLibraryFilters(cf);
    this.applyFilters(cf);
  }

  get filteredOtherLibCounts () {
    const lu = new Map<number, LibCount>();
    const currentFilterID = this.imageTypeFilter?.uid;
    for (const lc of this.otherLibCounts) {
      if (lc.val === currentFilterID) continue; // ignore ones that are in existing filter
      if (lu.has(lc.val)) {
        const libCount = lu.get(lc.val)!;
        libCount.count += lc.count ?? 1;
        lu.set(lc.val, libCount);
        continue;
      }

      lu.set(lc.val, {...lc, count: lc.count ?? 1 });
    }

    return Array.from(lu.values());
  }

  ngOnInit() {
    this._subscription = this.breakpointService.handset$.subscribe(
      isHandset => {
        this.isHandset = isHandset;
        if (this.isHandset) {
          this.gridLargeMode();
          this.RSVcontainer = false;
        }
      }
    );
    this.showFilters = this.isHandset === true ? false : true;

    if (this.modalSvc.isCurrentlyModal() === false) {
      this.overlaySvc.disableOverlay();
    }

    this.relatedSetControl = new FormControl('');

    this.filteredRelatedSets = this.relatedSetControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRelatedSets(value || ''))
    );

    if (!this.updateSeqMode) {
      this.relatedSetControl.valueChanges.subscribe(value => {
        this.relatedSetsSearcherOutput = value;
        // If user types something new, clear the UID
        if (this.relatedSetsSearcherOutputUID) {
          const existingSet = this.allRelatedSets.find(s => s.name === value);
          if (!existingSet) {
            this.relatedSetsSearcherOutputUID = null;
          }
        }
      });
    }

    this.mainLibraryControlsWidth$ = this.galleryTypeSvc.libraryFilterBarWidth$;
    this.imageTypeFilterSubscription = this.galleryTypeSvc.galleryTypeEmitter.subscribe(
      (t: ImageType) => {
        this.imageTypeFilter = t;
        this.civilianMode = this.galleryTypeSvc.CivilianResearchMode;
        this.prePrintedMode = this.galleryTypeSvc.prePrintedMode;
        this.showLedgerSetsView = this.galleryTypeSvc.LedgerSetsMode;

        if (this.galleryTypeSvc.LedgerSetsMode) {
        this.showLedgerSetsView = true;
        this.currentViewTitle = 'Ledgers';
        } else {
          this.showLedgerSetsView = false;
          this.libraryLedgerSets = [];
          this.currentViewTitle = 'Library';
          this.galleryTypeSvc.clearLibraryLedgerSets();
        }

        if (t.uid !== 0 && t.typeOfImage !== 'All') {
          this.galleryTypeSvc.LedgerSetsMode = false;
          this.showLedgerSetsView = false;
        }

        if (this.civilianMode) {
          this.rpp = 25;
        }
        if (this.prePrintedMode) {
          this.galleryTypeSvc.PrePrintedTypes.subscribe(ppt => this.prePrintedTypes = ppt);
        }
        
      });
    this.subscriptionList.push(this.imageTypeFilterSubscription);
    this.subscriptionList.push(this.galleryTypeSvc.libraryImagesRepaired.subscribe(() => {
      this.libImages = this.galleryTypeSvc.getLibraryImages();
    }));
    this.imageTypeFilter = this.galleryTypeSvc.getGalleryType();
    this.civilianMode = this.galleryTypeSvc.CivilianResearchMode;
    this.prePrintedMode = this.galleryTypeSvc.prePrintedMode;
    if (this.civilianMode) {
      this.rpp = 100;
    }
    if (this.prePrintedMode) {
      this.galleryTypeSvc.PrePrintedTypes.subscribe(ppt => this.prePrintedTypes = ppt);
    }
    this.isAdmin = this.loginSvc.getUserModel().isAdmin();
    this.loggedInUser = this.loginSvc.getUserModel();
    this.lastViewedRecord = this.galleryTypeSvc.getLastSelectedRecord();
    this.reloadData(this.imageTypeFilter);
    this.lookupSvc.getAllRelatedSets().subscribe(sets => {
      this.allRelatedSets = sets;
      console.log('Initial load - Related sets:', this.allRelatedSets?.length);
    }, error => {
      console.error('Error loading related sets:', error);
    });
    // preload some modals.
    this.selectModeModal = new StarbaseModalOptions('Selection Mode', '', [], StarbaseModalTypes.Info, this.selectModeTextModal);
    this.createImageSetModal = new StarbaseModalOptions(
      'Create Related Record Set',
      ``,
      [], StarbaseModalTypes.Notice, this.relateImageSetsModal);

    this.initSetViewMode();

    // if (this.galleryTypeSvc.LedgerSetsMode) {
    //   console.log('Library component detected ledger sets mode');
    //   this.showLedgerSetsView = true;
    //   this.currentViewTitle = 'Ledger Sets';
    //   this.loadLedgerSets();
    // }

    // this.route.queryParams.subscribe(params => {
    //   if (params.view === 'ledgersets') {
    //     this.showLedgerSetsView = true;
    //     // this.loadLedgerSets();
    //     this.reloadData(this.imageTypeFilter, true);
    //   }
    // });

    this.libSearch$ = of(new TypeaheadResults('', []));
    this.galleryTypeSvc.checkLibraryImages();
  }

  ngOnDestroy() {
    this.filterCancel$.next();
    this.filterCancel$.complete();
    for (const sub of this.subscriptionList) {
      if (sub) {
        sub.unsubscribe();
      }
    }
  }

  ngAfterViewInit() {
    if (this.galleryTypeSvc.hasReloaded) {
      setTimeout(() => {
        this.applyRefreshedSorts();
      }, 250);
    }

    this.selection.changed.subscribe(() => {
      this.batchEditImages = this.selection.selected;
      this.batchEditImages = this.batchEditImages.filter((img, i, x) => {
        return i === x.findIndex(y => y.uid === img.uid);
      });
      this.updateThumbnailSequences();
      this.cd.detectChanges();
    });
  }

  // private _filterRelatedSets(value: string): RelatedSetModel[] {
  //   if (!this.allRelatedSets || this.allRelatedSets.length === 0) {
  //     return [];
  //   }
  //   const filterValue = value.toLowerCase();
  //   return this.allRelatedSets.filter(set => 
  //     set.name && set.name.toLowerCase().includes(filterValue)
  //   ).slice(0, 10); // Limit to 10 results
  // }

  private _filterRelatedSets(value: string): RelatedSetModel[] {
    if (!this.allRelatedSets || this.allRelatedSets.length === 0) {
      return [];
    }
    
    if (!value || value.trim() === '') {
      // Show the most recent sets first (assuming higher UID = more recent)
      return this.allRelatedSets
        .sort((a, b) => (b.uid || 0) - (a.uid || 0))
        .slice(0, 10);
    }
    
    const filterValue = value.toLowerCase();
    return this.allRelatedSets
      .filter(rs => rs.name && rs.name.toLowerCase().includes(filterValue))
      .sort((a, b) => {
        // Prioritize exact matches
        const aExact = a.name.toLowerCase() === filterValue;
        const bExact = b.name.toLowerCase() === filterValue;
        if (aExact && !bExact) return -1;
        if (!aExact && bExact) return 1;
        // Then sort by recency
        return (b.uid || 0) - (a.uid || 0);
      })
      .slice(0, 10);
  }

  handleErrorLoadingFilterData(): void {
    this.setMessage('Could not load library collection or related data. ', 'red', true);
  }

  handleSelectRecord(e: ImageFile, lastViewedRecordIsRelatedResult = false) {
    this.galleryTypeSvc.setLastSelectedRecord(e);
    this.galleryTypeSvc.setLastViewedRecordRelatedSetStatus(lastViewedRecordIsRelatedResult); // FIXME: 
    this.galleryTypeSvc.setLibraryRelatedSetImages(this.relatedImageModels);
    this.galleryTypeSvc.setLibraryImages(this.libImages);
    this.galleryTypeSvc.setLibraryRelatedImageSetRecords(this.RISSearchResults, this.RISSearchLoadMoreClickedCount);
    this.router.navigate(['imageSingleView', e.uid]);
  }

  private updateThumbnailSequences(): void {
    if (!this.thumbnails) return;
    
    this.thumbnails.forEach(thumbnail => {
      const index = this.batchEditImages.findIndex(img => img.uid === thumbnail.imageData.uid);
      
      if (index > -1) {
        // Item is selected - set sequence number and selected state
        thumbnail.sequenceNumber = index + 1;
        thumbnail.selected = true;
      } else {
        // Item is not selected - clear sequence number and selected state
        thumbnail.sequenceNumber = 0;
        thumbnail.selected = false;
      }
      
      // Trigger change detection on the thumbnail
      thumbnail.changeDetection();
    });
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (!this.batchEditMode) return;
    this.mouseDownPoint = { x: event.clientX, y: event.clientY };
  }

  @HostListener('click', ['$event'])
  onContainerClick(event: MouseEvent) {
    if (!this.batchEditMode) return;
    
    // Check if this was a drag (mouse moved more than threshold)
    if (this.mouseDownPoint) {
      const distance = Math.sqrt(Math.pow(event.clientX - this.mouseDownPoint.x, 2) + Math.pow(event.clientY - this.mouseDownPoint.y, 2));
      this.mouseDownPoint = null;
      
      // If mouse moved more than threshold, it was a drag - don't clear selection
      if (distance > this.DRAG_THRESHOLD) {
        return;
      }
    }
    
    const target = event.target as HTMLElement;
    
    // Check if clicked on empty space (not on a thumbnail or UI element)
    const clickedOnThumbnail = target.closest('.thumbnail-selectable');
    const clickedOnButton = target.closest('app-slant-button');
    const clickedOnControls = target.closest('#mainLibraryControls');
    const clickedOnBatchEditForm = target.closest('.batchEditForm');
    const clickedOnModal = target.closest('.modal');
    const clickedOnFlowOptions = target.closest('.flowOptionsBar');
    const clickedOnResultInfo = target.closest('.resultSetInfo');
    const clickedOnSearchDropdown = target.closest('.search-dropdown');
    
    // If clicked on empty space (library floor), clear all selections
    if (!clickedOnThumbnail && !clickedOnButton && !clickedOnControls && !clickedOnBatchEditForm && !clickedOnModal && !clickedOnFlowOptions && !clickedOnResultInfo && !clickedOnSearchDropdown) {
      
      // Clear all selections
      this.selection.clear();
      this.batchEditImages = [];
      this.lastSelectedImage = null;
      
      // Update thumbnail sequences to clear the numbers
      this.updateThumbnailSequences();
      
      // If lasso directive exists, clear it too
      if (this.lassoDirective) {
        this.lassoDirective.clearSelection();
      }
      
      this.cd.detectChanges();
    }
  }

  handleThumbnailClick(img: ImageFile, event: MouseEvent) {
    // If not in batch edit mode, navigate to single view
    if (this.updateSeqMode) {
      return;
    } else if (!this.batchEditMode) {
      this.handleSelectRecord(img);
      return;
    }
    
    // Don't prevent default for Ctrl/Cmd clicks to allow browser behavior
    if (!event.ctrlKey && !event.metaKey) {
      event.preventDefault();
    }
    event.stopPropagation();
    
    if (event.shiftKey && this.lastSelectedImage) {
      // SHIFT + CLICK: Range selection
      const lastIndex = this.libImages.indexOf(this.lastSelectedImage);
      const currentIndex = this.libImages.indexOf(img);
      
      if (lastIndex !== -1 && currentIndex !== -1) {
        const start = Math.min(lastIndex, currentIndex);
        const end = Math.max(lastIndex, currentIndex);
        
        // If not holding Ctrl/Cmd, clear existing selection first
        if (!event.ctrlKey && !event.metaKey) {
          this.selection.clear();
          this.batchEditImages = [];
        }
        
        // Add range to selection
        const range = this.libImages.slice(start, end + 1);
        range.forEach(image => {
          if (!this.selection.isSelected(image)) {
            this.selection.select(image);
            this.batchEditImages.push(image);
          }
        });
        
        // Don't update lastSelectedImage for shift+click
      }
    } else if (event.ctrlKey || event.metaKey) {
      // CTRL/CMD + CLICK: Toggle single selection
      if (this.selection.isSelected(img)) {
        // Deselect
        this.selection.deselect(img);
        const index = this.batchEditImages.findIndex(i => i.uid === img.uid);
        if (index > -1) {
          this.batchEditImages.splice(index, 1);
        }
        
        // If we deselected the last selected image, clear it
        if (this.lastSelectedImage?.uid === img.uid) {
          this.lastSelectedImage = null;
        }
      } else {
        // Select
        this.selection.select(img);
        this.batchEditImages.push(img);
        this.lastSelectedImage = img;
      }
    } else {
      // NORMAL CLICK: Replace selection with just this item
      const wasSelected = this.selection.isSelected(img);
      
      this.selection.clear();
      this.batchEditImages = [];
      
      // If the item wasn't selected, select it
      // If it was selected and we're clicking without modifiers, we still select just it
      this.selection.select(img);
      this.batchEditImages = [img];
      this.lastSelectedImage = img;
    }
    
    this.batchEditImages = this.batchEditImages.filter((img, i, x) => {
      return i === x.findIndex(y => y.uid === img.uid);
    });
    
    // Always update sequences after any selection change
    this.updateThumbnailSequences();
    this.cd.detectChanges();
    }

  scrollToLastViewedThumbnail() {
    if (!this.lastViewedRecord || this.lastViewedRecord.uid === 0) {
      return;
    }

    setTimeout(() => { // wait for animations to load
      const isRelatedResult = this.galleryTypeSvc.getLastViewedRecordRelatedSetStatus();
      const elementID = `thumbnail${isRelatedResult? "-related": ""}${this.lastViewedRecord.uid}`
      const el = document.getElementById(elementID);

      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        this.cd.markForCheck();
      } // scroll the last viewed element into view
    }, 1200);
  }

  removeOutlineFromThumbnail() {
    this.thumbnails['results'].forEach(el => {
      el.nativeElement.classList.remove('focus');
    });
  }

  public setViewMode(viewMode: string) {
    switch (viewMode) {
      case 'condensedMode':
        this.condensedMode();
        break;
      case 'gridLargeMode':
        this.gridLargeMode();
        break;
      case 'listMode':
        this.listMode();
        break;
      case 'gridSummaryMode':
        this.gridSummaryMode();
    }
    this.cd.markForCheck();
  }


  pagesAvailable = (): number => this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp).totalPages;

  currentPage = (): number => this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp).page;

  totalRecords = (): number => this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp).totalRecords;

  changeRpp(): void {
    const cf: FilterParams<ImageFile> = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    cf.page = 1;
    this.galleryTypeSvc.setLastSelectedRecord(undefined);
    this.galleryTypeSvc.setLastViewedRecordRelatedSetStatus(false);
    this.lastViewedRecord = undefined;
    this.applyFilters(cf);
  }

  changeLibrary(imageTypeId: number): void {
    const nit = new ImageType(this.allImageTypesVirtual.find(i => i.val === imageTypeId).txt);
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters(); // save current settings
    cf.removeFromFilter('TypeOfImageId', this.imageTypeFilter.uid.toString()); // get rid of current image type filter
    cf.page = 1;
    this.galleryTypeSvc.setGalleryType(nit);
    this.imageTypeFilter = nit;
    this.galleryTypeSvc.setCurrentLibraryFilters(cf); // restore settings
    this.reloadData(nit, true);
  }

  libSelectConfigLookup(typeId: number): LibSelectConfig {
    const lib = GatewayLibSelects.LibSelectArray.find(l => l.imageType.uid === typeId);
    if (lib) {
      return lib;
    } else {
      console.log('No pre-defined Lib Select Button for Image Type ' + typeId);
      const imgTypeVirt = this.allImageTypesVirtual.find(i => i.val === typeId);
      const imgTypeConcrete = new ImageType(imgTypeVirt.txt);
      imgTypeConcrete.uid = typeId;
      const ins = new LibSelectConfig(
        imgTypeConcrete,
        '../../assets/cropped-RESEARCH-ARSENAL_LOGO_BLUE-192x192.png',
        'center',
        undefined,
        'contain');
      GatewayLibSelects.LibSelectArray.push(ins);
      return ins;
    }
  }

  applyRefreshedSorts() {
    const reloadedFilters = this.galleryTypeSvc.getCurrentLibraryFilters();

    if (reloadedFilters.sortFields && reloadedFilters.sortFields.length > 0) {
      for (const sortField of reloadedFilters.sortFields) {
        switch (sortField) {
          case 'Name':
            this.currentSort = 0;
            break;

          case 'Relevance':
            this.currentSort = 3;
            break;

          case 'NumericSortString':
            this.currentSort = 1;
            break;

          case 'SequenceNumber':
            this.currentSort = 4;
            break;

          default:
            this.currentSort = 2;
            break;
        }
      }
    }

  }

  // re-sorting
  resortCurrentLibrary(sortMode: string): void {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    cf.sortFields = [];
    cf.sortStringNumerically = false;
    this.sortChanged = true;
    if (sortMode === '0') { // A-Z
      this.currentSort = 0;
      cf.sortFields[0] = 'Name';
      this.applyFilters(cf);
    } else if (sortMode === '1') { // Numerically
      this.currentSort = 1;
      cf.addToSorts('NumericSortString');
      this.applyFilters(cf);
    } else if (sortMode === '2') {
      this.currentSort = 2;
      this.applyFilters(cf);
    } else if (sortMode === '3') {
      this.currentSort = 3;
      cf.sortFields[0] = 'Relevance';
      this.applyFilters(cf);
    } else if (sortMode === '4') {
      this.currentSort = 4;
      cf.sortFields[0] = 'SequenceNumber';
      this.applyFilters(cf);
    }
  }

  togglePrePrintedType(type: ImageType): void {
    this.galleryTypeSvc.togglePrePrintedType(type.uid, !type.selected);

    this.reloadData(this.imageTypeFilter, true);
  }
  toggleAllPrePrintedSelections() {
    const allOrNone = !(this.prePrintedTypesSelected.length > (this.prePrintedTypes.length / 2));
    this.prePrintedTypes.forEach(t => t.selected = allOrNone);
    this.galleryTypeSvc.togglePrePrintedType(0, allOrNone); // 0 for all items

    this.reloadData(this.imageTypeFilter, true);
  }

  toggleAllCivilianSelections(): void {
    const allOrNone = !(this.civilianTypesSelectedCount > (this.otherLibCounts.length / 2));
    this.otherLibCounts.forEach(t => t.selected = allOrNone);
    
    if (allOrNone) {
      // If selecting all, apply filters with all types
      this.filterCivs();
    } else {
      // If deselecting all, clear the library and show message
      this.libImages = [];
      this.setMessage('You have deselected all libraries. No results will be displayed.', 'black');
      const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
      cf.replaceFilter('TypeOfImageId', '');
      this.galleryTypeSvc.setCurrentLibraryFilters(cf);
    }
    
    this.cd.markForCheck();
  }

  /** Reloads all data for this view, including the filter options data.
   * If `forceReloadFromServer` is false, then this function will attempt to reload data from cache first.
   *
   * @param imgType The ImageType object to use for creating the appropriate filters.
   * @param forceReloadFromServer Optional. Defaults to false.
   *  If true, will always load fresh data from the server. If false, will try to load data from the cache first. */
  public reloadData(imgType: ImageType, forceReloadFromServer = false): void {
    const cf: FilterParams<ImageFile> = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    this.lastSearchString = cf.searchPhrase;
    this.libMainSearch.searchText = this.lastSearchString;

    // if (this.galleryTypeSvc.LedgerSetsMode) {
    //   console.log('In ledger mode - loading ledger sets');
    //   this.showLedgerSetsView = true;
    //   this.currentViewTitle = 'Ledger Sets';
    //   this.loadLedgerSets();
    //   //return; // Don't proceed with normal image loading
    // }

    this.isLoading = true;
    if (!this.galleryTypeSvc.LedgerSetsMode) {
      this.showLedgerSetsView = false;
      this.libraryLedgerSets = [];
      this.galleryTypeSvc.clearLibraryLedgerSets();
    }
    
    this.mainLibraryFilter.loadFilterOptionsData();
    
    if (this.galleryTypeSvc.LedgerSetsMode) {
      this.showLedgerSetsView = true;
      this.currentViewTitle = 'Ledgers';
      
      // Load ledgers directly
      const fp = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
      this.applyLedgerFilters(fp);
      this.isLoading = false;
      return; 
    }

    this.showLedgerSetsView = false;
    this.currentViewTitle = 'Library';

    if (this.galleryTypeSvc.CountOfRISRecords > 0) {
      const rsData = this.galleryTypeSvc.getLibraryRelatedImageSetRecords();
      this.RISSearchLoadMoreClickedCount = this.galleryTypeSvc.lastRelatedImageSetLoadMoreCount;
      this.initRSSearchResults(rsData);
    }
    this.applyRefreshedSorts();

    // Attempts to load from cached image library if the cache has data and if this method is not being invoked with 'forceReloadFromServer.
    if (this.galleryTypeSvc.CountOfLibImages > 0 && !forceReloadFromServer) {
      this.libImages = this.galleryTypeSvc.getLibraryImages(this.rpp * cf.page);
      this.setMessage();
      this.mainLibraryFilter.loadFilterOptionsData();
      if (this.civilianMode === true) {
        if (!this.otherLibCounts.length) {
          this.maintainLibrary = true;
          this.setOtherLibCounts(); // if civ mode and we haven't already run this
        }
      } else {
        this.setOtherLibCounts();
      }
      this.scrollToLastViewedThumbnail();
      if (this.isHandset) {
        this.gridLargeMode();
      }
      return;
    }

    this.setMessage(LOADING_MESSAGE);
    // This section of the method will be run if we are loading fresh data from the server
    // eslint-disable-next-line eqeqeq
    if (!imgType || imgType.uid == 0 || imgType.typeOfImage.toLowerCase() === 'all' || imgType.typeOfImage == '') {
      if (this.prePrintedMode) {
        // load the latest vals and selected types
        this.galleryTypeSvc.PrePrintedTypes.subscribe(ppt => {
          // reset all image types in filter in case user has unchecked some
          cf.replaceFilter('TypeOfImageId', '');
          this.prePrintedTypes = ppt;
          // loop through all selected pre-printed Image Types
          if (this.prePrintedTypesSelected.length === 0) {
            this.libImages = [];
            this.setMessage('Choose at least one pre-printed form type to see results.');
            return;
          }
          this.prePrintedTypesSelected.forEach(p => cf.addToFilter('TypeOfImageId', p.uid));
          this.applyFilters(cf);
        });
      } else {
        this.applyFilters(cf);
      }
    } else {
      cf.addToFilter('TypeOfImageId', imgType.uid);
      this.applyFilters(cf);
    }
    this.mainLibraryFilter.loadFilterOptionsData();
    if (cf.sortFields?.length > 0) {
      // eslint-disable-next-line eqeqeq
      if (cf.sortFields[0] == 'SequenceNumber') {
        this.currentSort = 4;
      }
    }
    // eslint-disable-next-line @typescript-eslint/no-shadow
    if (cf.filters.some(filter => filter.includes('SequenceNumber')) && this.updateSeqMode) {
      this.currentSort = 4;
    }

    this.isLoading = false;
  }

  // called when user is typing. Used for checking cleared search
  quickSearchTyping(txtOut: string): void {
    // eslint-disable-next-line no-console
    console.info('searchTerm = ' + txtOut);
    if (!txtOut || txtOut === '') {
      if (this.lastSearchString) { // if we had a search active, clear it
        const cf = this.resetSearchableFields(this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp));
        if (this.currentSort === 3 || this.currentSort === 4) { //If relevance sort is applied clear the sort
          this.currentSort = 2;
          cf.sortFields = [];
        }
        this.applyFilters(cf);
      }
      this.lastSearchString = '';
    }
  }

  clearSearchAndResetCivLibs(){
    this.clearSearch();
    if (this.civilianMode) {
      this.setOtherLibCounts();
    }
    // if (this.galleryTypeSvc.LedgerSetsMode) {
    //   this.loadLedgerSets();
    // }
  }

  clearSearch() {
    this.libMainSearch.clearEvent();
    if (this.keywordFilterActive || this.relatedSetNameFilterActiveName || this.relatedSetNameFilterActiveUID) {
      this.removeFilters();
    }

    // if (this.galleryTypeSvc.LedgerSetsMode) {
    //   this.loadLedgerSets();
    // }
  }

  removeFilters() {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    // mainLibraryFilter will emit and this component will respond by calling applyFilters().
    this.mainLibraryFilter.resetFilters(true, cf, true, false);
    this.setOtherLibCounts();

    // if (this.galleryTypeSvc.LedgerSetsMode) {
    //   this.loadLedgerSets();
    // }
  }

  removeKeywordFilter() {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    cf.replaceFilter('ImageKeywords.LU_KeywordUID', '');
    cf.searchPhrase = '';
    cf.sortFields = [];
    this.lastSearchString = ''; this.galleryTypeSvc.storeKeywordFilter('');
    this.libMainSearch.searchText = this.lastSearchString;
    this.RISSearchResults = [];
    this.mainLibraryFilter.resetFilters(true, cf, false, true);
    // if (this.galleryTypeSvc.LedgerSetsMode) {
    //     // Reload all ledger sets (no filters)
    //     this.loadLedgerSets();
    //   } else {
        // Regular image filtering
        this.applyFilters(cf);
      // }
    this.currentSort = 2;
  }

  removeRelatedSetNameFilter() {
    //TODO: Maybe update?
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    cf.replaceFilter('RelatedSetUID', '');

    this.galleryTypeSvc.storeRelatedSetNameFilter('');
    this.currentSort = 2;
    cf.sortFields = [];
    if (this.updateSeqMode === true) {
      this.turnOffUpdateSequenceMode('1');
    }
    this.applyFilters(cf);
  }
  // called when Enter key (or search icon) is pressed by LibrarySearchComponent
  quickSearchDataResults(results: TypeaheadResults) {
    if (!results) {
      this.lastSearchString = ''; return;
    }
    try {
      // this.libImages = results;
      // this.libImages.map(i => i = i.deserialize(i));
      this.setMessage(LOADING_MESSAGE);
      console.log(results);
      let cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
      // reset all searchable filter fields, since we just run one of these at a time (for now)
      cf = this.resetSearchableFields(cf);
      cf.page = 1;
      if (results.selected) { // then user chose a specific item in dropdown
        const theKey = Object.keys(results.matches[0].hits);
        const kf: IFilterEventData = {
          selected: true,
          entity: results.matches[0].tableName + ':' + theKey[0],
          obj: results.matches[0].hits[theKey[0]][0],
          allSelected: null
        };

        // translate by key
        switch (kf.entity) {
          case 'KeywordsImageTypeView:keyword':
          case 'entityType:keyword':
            if (isNaN(+kf.obj)) {
              cf.searchPhrase = kf.obj;
              cf.explicitSearchProperties = ['Keyword'];
              cf.exactMatch = true;
              break;
            }
            cf.addToFilter('ImageKeywords.LU_KeywordUID', kf.obj);
            break;
          case 'ImagesSearchView:name':
          case 'entityType:name':
            if (kf.obj.length < 30) {
              cf.addToFilter('Name', kf.obj);
            } else {
              // cf.searchPhrase = this.truncateTextAtWord(kf.obj, results.userInput, 16, 5);
              cf.searchPhrase = kf.obj;
              cf.explicitSearchProperties = ['Name'];
              cf.exactMatch = true;
            }
            break;
          case 'ImagesSearchView:notes':
          case 'entityType:notes':
            if (kf.obj.length < 30) {
              cf.addToFilter('Notes', kf.obj);
            } else {
              // cf.searchPhrase = this.truncateTextAtWord(kf.obj, results.userInput, 16, 5);
              cf.searchPhrase = kf.obj;
              cf.explicitSearchProperties = ['Notes'];
              cf.exactMatch = true;
            }
            break;
          case 'ImagesSearchView:transcription':
          case 'entityType:transcription':
            if (kf.obj.length < 30) {
              cf.addToFilter('Transcription', kf.obj);
            } else {
              // cf.searchPhrase = this.truncateTextAtWord(kf.obj, results.userInput, 16, 5);
              cf.searchPhrase = kf.obj;
              cf.explicitSearchProperties = ['Transcription'];
              cf.exactMatch = true;
            }
            break;
          case 'ImagesSearchView:callNo':
          case 'entityType:callNo':
            cf.addToFilter('CallNo', kf.obj);
            break;
          case 'ImageIndividualsWithFullNameView:firstName':
          case 'ImageIndividualsWithFullNameView:lastName':
          case 'ImageIndividualsWithFullNameView:fullName':
          case 'entityType:fullName':
            cf.addToFilter(
              'ImageIndividuals.FirstName',
              kf.obj.split(' ')[0]); // NOTE: This is messy. If there's a legitimate space in either field, this will break.
            cf.addToFilter('ImageIndividuals.LastName', kf.obj.split(' ')[1]); // " "
            break;
          case 'ImageIndividualModel:individualNotes':
          case 'ImageIndividualsWithFullNameView:individualNotes':
          case 'entityType:individualNotes':
            cf.addToFilter('ImageIndividuals.Notes', kf.obj);
            cf.exactMatch = true;
            break;
          default:
            console.error('Library Search: attempting to search by an unsupported field.');
        }
        // fp.addToFilter(theKey[0], results.matches[0].hits[theKey[0]][0]);
        this.lastSearchString = theKey[0].toUpperCase() + ': ' + results.matches[0].hits[theKey[0]];
      } else { // otherwise just search by the term
        this.lastSearchString = results.userInput.toLowerCase();
        cf.searchPhrase = results.userInput;
        cf.exactMatch = false;
        cf.explicitSearchProperties = this.libMainSearch.getFilterExplicitProperties();
      }
      if (!this.sortChanged) {
        this.currentSort = 3;
        cf.sortFields[0] = 'Relevance';
      }
      this.applyFilters(cf); // execute search
      this.listMode();
    } catch (e) {
      this.searchError(e);
    }
  }
  searchError(e: any): void {
    setTimeout(() =>
      this.setMessage('Something went wrong when running the search.', 'red', false, true), 1);
    console.error(e);
    this.appInsightsSvc.logError(e);
    this.cd.detectChanges();
  }
  resetSearchableFields(cf: FilterParams<ImageFile>): FilterParams<ImageFile> {
    cf.replaceFilter('ImageKeywords.LU_KeywordUID', '');
    this.galleryTypeSvc.storeKeywordFilter('');
    cf.replaceFilter('Name', '');
    cf.replaceFilter('Notes', '');
    cf.replaceFilter('Transcription', '');
    cf.replaceFilter('CallNo', '');
    cf.replaceFilter('ImageIndividuals.FirstName', '');
    cf.replaceFilter('ImageIndividuals.LastName', '');
    cf.replaceFilter('ImageIndividuals.Notes', '');
    cf.searchPhrase = undefined;
    return cf;
  }

  // relatedSetsTypeahead = (text$: Observable<string>) => // TODO: set up to work the same way as typeaheads on SingleImageComponent
  //   text$.pipe(
  //     debounceTime(350),
  //     distinctUntilChanged(),
  //     switchMap(term =>
  //       term.length < 2 ? of([])
  //         : of(
  //           this.allRelatedImageSets.map(r => r.name).filter(r =>
  //           r.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 5)
  //         )
  //     )
  //   )

  relatedSetsTypeahead(): (text: Observable<string>) => Observable<RelatedSetModel[]> {
    return (text$: Observable<string>) =>
      text$.pipe(
        debounceTime(350),
        distinctUntilChanged(),
        switchMap(term => {
          
          if (!term || term.length < 2) {
            return of([]);
          }
          
          if (!this.allRelatedSets || this.allRelatedSets.length === 0) {
            return of([]);
          }
          
          const filtered = this.allRelatedSets.filter(rs =>
            rs.name && rs.name.toLowerCase().includes(term.toLowerCase())
          );
          
          return of(filtered.slice(0, 10));
        })
      );
    }

  // private loadLedgerSets(): void {
  //   console.log('Loading ledger sets...');
  //   this.setMessage(LOADING_MESSAGE);
    
  //   this.lookupSvc.getLedgerSetsForGallery().subscribe({
  //     next: (response: FilterParams<RelatedImageSetViewDataModel>) => {
  //       console.log('Ledger sets API response:', response);
        
  //       // Extract the ledger sets
  //       this.libraryLedgerSets = response.collection || [];
        
  //       this.galleryTypeSvc.setCurrentLedgerFilters({
  //         page: response.page || 1,
  //         rpp: response.rpp || response.collection.length,
  //         totalRecords: response.totalRecords || response.collection.length,
  //         totalPages: response.totalPages || 1
  //       });

  //       console.log('Pagination set:', {
  //         totalRecords: this.totalRecords(),
  //         totalPages: this.pagesAvailable(),
  //         currentPage: this.currentPage(),
  //         rpp: response.rpp
  //       });

  //       // Clear regular library images
  //       this.libImages = [];
  //       this.setMessage('');
  //       this.currentViewTitle = 'Ledger Sets';
  //       this.cd.markForCheck();
  //     },
  //     error: (error) => {
  //       console.error('Error loading ledger sets:', error);
  //       this.setMessage('Error loading ledger sets', 'red', true);
  //       this.cd.markForCheck();
  //     }
  //   });
  // }

  onTypeaheadInput(value: string): void {
    // Reset the UID if user is typing something different
    if (this.relatedSetsSearcherOutputUID && value !== this.relatedSetsSearcherOutput) {
      this.relatedSetsSearcherOutputUID = null;
    }
  }

  interceptTypeaheadSelection(event: NgbTypeaheadSelectItemEvent) {
    const selectedSet = event.item;
    // Set both the name and UID for existing set
    this.relatedSetsSearcherOutput = selectedSet.name;
    this.relatedSetsSearcherOutputUID = selectedSet.uid;
    
    // Clear the dropdown selection since user chose from typeahead
    this.selectedImageSetUIDDropdown = null;
    
    // Don't prevent default - let the selection happen
    this.cd.markForCheck();
  }

// This method getTotalGroupCount takes an imageTypeId as a parameter and returns the total count
// of the matching image type in the 'otherLibCounts' array.
// @param {number} imageTypeId - The unique identifier for the image type.
// @returns {number} - The total count of the matching image type, or undefined if not found.
  getTotalGroupCount(imageTypeId: number): number {
    for (const i in this.otherLibCounts){
      if(this.otherLibCounts[i].val === imageTypeId){
        return this.otherLibCounts[i].count;
      }
    }
  }
    // private setPresentImageTypes(): void {
  //   if (this.libImages.length) {
  //     this.presentImageTypes = this.allImageTypesVirtual.filter(a => this.libImages.some(b => b.typeOfImageId === a.val));
  //     this.presentImageTypes.map(p => p.selected = true);
  //   } else {
  //     this.presentImageTypes = [];
  //   }
  // }


  // This method filterCivs adds the currently selected libraries's ID in string to the current gallery service filter variable.
  filterCivs(): void {
    if (this.civilianMode) {
        const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
        cf.replaceFilter('TypeOfImageId', '');
        const selectedCivLibs = this.filteredOtherLibCounts.filter(p => p.selected);
        if (selectedCivLibs.length) {
          cf.addToFilter('TypeOfImageId', selectedCivLibs.map(f => f.val).join('|'));
        }
        if (selectedCivLibs.length === 0) {
          this.libImages = [];
          this.setMessage('You have deselected all libraries. No results will be displayed.', 'black');
          this.galleryTypeSvc.setCurrentLibraryFilters(cf);
          return;
        }
        this.applyFilters(cf);
      }
  }
// This method applyCRfilters takes a filterParam as a parameter and sets the reloaded filters for Civilian Reserach library.
// @param {FilterParams<ImageFile>} fp - Reloaded filters imageFile, passed from other methods
// once they fetch this param from gallery type service.
  applyCRfilters(fp: FilterParams<ImageFile>) {
    if(this.civilianMode){
      this.imgSvc.civilianRecordsInfo(true).subscribe(civResearchRecordsInfo => {
        this.otherLibCounts = [];
        const typeMap = new Map(this.allImageTypesVirtual.map(type => [type.val, type]));

        for (const iterable of civResearchRecordsInfo) {
          const type = typeMap.get(iterable.typeOfImageId);

          if (type) {
            this.otherLibCounts.push({
              val: type.val,
              txt: type.txt,
              count: iterable.count,
              selected: true
            });
          }
        }
        // Finding the 'TypeOfImageId index'
        let reloadedTypeOfImageIdIndex: number;
        fp.filters.some((outerArray, outerIndex) => {
          if (Array.isArray(outerArray)) {
            const typeOfImageIdIndex= outerArray.some(ele => ele === 'TypeOfImageId');
            if (typeOfImageIdIndex){
              reloadedTypeOfImageIdIndex = outerIndex;
            }
          }
        });
        if (fp.filters[reloadedTypeOfImageIdIndex]) {
          const selectedCivLibs = fp.filters[reloadedTypeOfImageIdIndex][1].split('|').map(type => parseInt(type, 10));
          this.otherLibCounts.forEach(lib => lib.selected = selectedCivLibs.some(selectedLib => selectedLib  === lib.val) ? true: false);
        } else {
          this.otherLibCounts.forEach(lib => lib.selected = true);
        }
        this.maintainLibrary = false;
        this.cd.detectChanges();
      });
    }
  }

  libSearchExecuted() {
    this.toggleFiltersSection();
    this.toggleRSV();
    if (this.isHandset){
      const el = document.getElementById('showFilterContainer');
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest'
        });
        this.cd.markForCheck();
        }
    }
  }

  loadMoreRSImages() {
    const currentLength = this.RISSearchResultsToDisplay.length;
    this.RISSearchLoadMoreClickedCount++;
    const nextItems = this.RISSearchResults.slice(currentLength, currentLength + 10);
    this.RISSearchResultsToDisplay = this.RISSearchResultsToDisplay.concat(nextItems);

    if (this.RISSearchResultsToDisplay.length >= this.RISSearchResults.length) {
      this.loadMoreRSButton = false;
    }
    this.cd.markForCheck();
  }

  isRelatedImageSetPresent(fp) {
    return fp.some(subArray => subArray.includes('SequenceNumber'));
  }

  // to be called from BE method and SIV to lib back to gallery button scenario..
  initRSSearchResults(relatedImageSets: RelatedImageSetViewDataModel[]) {
    this.relatedImageSets = relatedImageSets;
    if (relatedImageSets.length >= 10) {
      this.RISSearchResultsToDisplay = [...relatedImageSets.slice(0,this.RISSearchLoadMoreClickedCount*10)];
      this.RISSearchResults = relatedImageSets;
      this.loadMoreRSButton = true;
    } else {
      this.RISSearchResultsToDisplay = [...relatedImageSets];
      this.RISSearchResults = relatedImageSets;
    }

    if (this.RISSearchResultsToDisplay?.length > 0) {
      this.showRSthumbnails = true;
    }
    if (this.isHandset) {
      this.gridLargeMode();
    }
  }

  getAllImagesForRS(fp: FilterParams<ImageFile>) {
    this.setMessage(LOADING_MESSAGE);
    // eslint-disable-next-line eqeqeq
    const countFirstFilter = !this.imageTypeFilter
      || this.imageTypeFilter.uid === 0
      || this.imageTypeFilter.typeOfImage.toLowerCase() === 'all'
      || this.imageTypeFilter.typeOfImage === '';
    if (fp.orClusterFilters.length) {
      this.reportFilters(fp);
    } else if (fp.filters.length > (countFirstFilter ? 0 : 1)) {
      this.reportFilters(fp);
    } else if (fp.searchPhrase && fp.searchPhrase.length > 1) {
      this.reportFilters(fp);
    }
    this.filterCancel$.next();
    this.cd.markForCheck();

    this.imageFilteredSubscription = this.imgSvc.getAllRSImagesByFilterParams(fp)
      .pipe(
        finalize(() => this.cd.markForCheck()),
        takeUntil(this.filterCancel$))
      .subscribe(d => {
        if (isDevMode() || environment.testMode) {
          d.collection.map((i: ImageFile) => {
            i.thumbnailPath = i.thumbnailPath.replace('wwwroot/', ''); // fix local dev server hosting
          }
          );
        }

        this.libImages = d.collection; // replace data

        if (d.collection.length === 0) {
          this.setMessage('No results. Try changing your search parameters or press', null, false, true);
        } else {
          this.setMessage();
        }
        this.galleryTypeSvc.setLibraryImages(this.libImages);
        this.galleryTypeSvc.setCurrentLibraryFilters(d); // save the filterParams to the service if the load was successful
        // this.setPresentImageTypes(); // currently only leveraged in Civilian Research Mode but might be useful in View All library.
        if (this.civilianMode === true) {
          if (!this.otherLibCounts.length) {
            this.maintainLibrary = true;
            this.setOtherLibCounts(); // if civ mode and we haven't already run this
          }
        } else {
          this.setOtherLibCounts();
        }

        this.scrollToLastViewedThumbnail();

        this.currentSort = 4;
      }, err => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Error',
            err['friendly'],
            undefined, undefined, StarbaseNotificationSentiment.Error));
          this.setMessage('An error occurred when loading the library.', 'red', true, false);
          this.libImages = [];
          console.error(err);
      }, () => {
        this.loadMoreText = SHOWMORE_TEXT;
      });
    this.subscriptionList.push(this.imageFilteredSubscription);
    return this.imageFilteredSubscription;
  }

  launchRSSearch(fp: FilterParams<ImageFile>) {
    if (this.lastSearchString?.length > 1) {
      // fp.sortFields[0] = 'Related';
      // fp.sortAsc = true;
      // fp.filters = fp.filters.filter(f => f[0] !== 'SequenceNumber');
    //this.setMessage(LOADING_MESSAGE);
    this.imgSvc.getRelatedSetViewDataByFilterParamsBroadSearch(
      fp)
      .pipe(
        finalize(() => this.cd.markForCheck()),
        takeUntil(this.filterCancel$)).subscribe(({ relatedImageModels, relatedImages }) => {
          this.relatedImageModels = relatedImageModels ?? [];
          this.galleryTypeSvc.setLibraryRelatedSetImages(this.relatedImageModels);
          if (isDevMode() || environment.testMode) {
            relatedImages?.forEach(rsRecord => {
              rsRecord.thumbnailImage.thumbnailPath = rsRecord.thumbnailImage.thumbnailPath.replace('wwwroot/', ''); // fix local dev server hosting
            });
          }

          this.RISSearchLoadMoreClickedCount = 1;
          this.initRSSearchResults(relatedImages ?? []);
          if (this.keepRSThumbnailsHidden) {
            this.showRSthumbnails = false;
            this.cd.detectChanges();
          }
          //this.setMessage();
          }, err => {
            this.notiSvc.postNotification(
              this.notiSvc.notificationBuilder(
                'Error',
                err['friendly'],
                undefined, undefined, StarbaseNotificationSentiment.Error));
              //this.setMessage('An error occurred when loading the library.', 'red', true, false);
              //this.libImages = [];
              console.error(err);
          }, () => {
            this.loadMoreText = SHOWMORE_TEXT;
          }
        );
      } else {
        this.RISSearchResultsToDisplay = [];
        this.RISSearchResults = [];
        this.showRSthumbnails = false;
        this.cd.markForCheck();
      }
  }

  applyFilters(fp: FilterParams<ImageFile>, appendLibImages: boolean = false): Subscription {
    
    if (!appendLibImages) {
      this.setMessage(LOADING_MESSAGE);
    } else {
      this.loadMoreText = LOADING_MESSAGE;
    }
    // eslint-disable-next-line eqeqeq
    const countFirstFilter = !this.imageTypeFilter
      || this.imageTypeFilter.uid === 0
      || this.imageTypeFilter.typeOfImage.toLowerCase() === 'all'
      || this.imageTypeFilter.typeOfImage === '';
    if (fp.orClusterFilters.length) {
      this.reportFilters(fp);
    } else if (fp.filters.length > (countFirstFilter ? 0 : 1)) {
      this.reportFilters(fp);
    } else if (fp.searchPhrase && fp.searchPhrase.length > 1) {
      this.reportFilters(fp);
    }
    this.filterCancel$.next();
    this.cd.markForCheck();

    if (this.galleryTypeSvc.LedgerSetsMode) {
      this.showLedgerSetsView = true;
      this.applyLedgerFilters(fp);
      return;
    }
    
    this.imageFilteredSubscription = this.imgSvc.getDataByFilterParamsBroadSearch(
      this.imgSvc.broadSearchUri + (this.civilianMode ? '?civilianMode=true' : ''),
      fp)
      .pipe(
        finalize(() => this.cd.markForCheck()),
        takeUntil(this.filterCancel$))
      .subscribe(d => {
        if (isDevMode() || environment.testMode) {
          d.collection.map((i: ImageFile) => {
            i.thumbnailPath = i.thumbnailPath.replace('wwwroot/', ''); // fix local dev server hosting
          }
          );
        }
        if (appendLibImages) {
          this.libImages = [...this.libImages, ...d.collection]; // append data
        } else {
          this.libImages = Array.from(d.collection); // replace data
        }

        if (d.collection.length === 0) {
          this.setMessage('No results. Try changing your search parameters or press', null, false, true);
        } else {
          this.setMessage();
        }

        this.galleryTypeSvc.setLibraryImages(this.libImages);
        this.galleryTypeSvc.setCurrentLibraryFilters(d); // save the filterParams to the service if the load was successful
        this.cd.detectChanges();
        // this.setPresentImageTypes(); // currently only leveraged in Civilian Research Mode but might be useful in View All library.
        if (this.civilianMode === true) {
          if (!this.otherLibCounts.length) {
            this.maintainLibrary = true;
            this.setOtherLibCounts(); // if civ mode and we haven't already run this
          }
        } else {
          this.setOtherLibCounts();
        }

        this.scrollToLastViewedThumbnail();
        this.launchRSSearch(fp);
      }, err => {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Error',
            err['friendly'],
            undefined, undefined, StarbaseNotificationSentiment.Error));
          this.setMessage('An error occurred when loading the library.', 'red', true, false);
          this.libImages = [];
          console.error(err);
      }, () => {
        this.loadMoreText = SHOWMORE_TEXT;
      });
    this.subscriptionList.push(this.imageFilteredSubscription);
    return this.imageFilteredSubscription;
  }

  get hasActiveFilters(): boolean {
    const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
    
    // Check if we have filters or search phrase
    const hasFilters = (cf.filters && cf.filters.length > 0);
    const hasSearch = (cf.searchPhrase && cf.searchPhrase.trim().length > 0);
    
    return hasFilters || hasSearch;
  }

  private applyLedgerFilters(fp: FilterParams<ImageFile>): Subscription {
    if (!this.galleryTypeSvc.LedgerSetsMode) {
      console.warn('applyLedgerFilters called but not in ledger mode');
      return new Subscription();
    }

    this.setMessage(LOADING_MESSAGE);
    this.lastSearchString = fp.searchPhrase;
    if (fp.page === 1) {
      this.libraryLedgerSets = [];
    }

    this.filterCancel$.next();
    this.cd.markForCheck();

    fp.collection = [];
    const subscription = this.lookupSvc.getLedgerSetsByFilterParams(fp)
      .pipe(
        finalize(() => this.cd.markForCheck()),
        takeUntil(this.filterCancel$)
      )
      .subscribe({
        next: (response: any) => {
          
          // Store the filtered ledger sets
          this.libraryLedgerSets = response.collection;

          // Store in service for caching
          this.galleryTypeSvc.setLibraryLedgerSets(this.libraryLedgerSets);
          this.galleryTypeSvc.setLibraryImages(this.libraryLedgerSets.map(l => l.thumbnailImage));
          this.galleryTypeSvc.setCurrentLibraryFilters(fp);
          
          // Update pagination metadata
          this.galleryTypeSvc.setCurrentLedgerFilters({
            page: response.page || 1,
            rpp: response.rpp || response.collection.length,
            totalRecords: response.totalRecords || response.collection.length,
            totalPages: response.totalPages || 1
          });
          
          // Update display
          if (this.libraryLedgerSets.length === 0) {
            this.setMessage('No ledgers contain images matching your filters.', 'black', false, true);
          } else {
            this.setMessage('');
            this.showLedgerSetsView = true;
            this.isLoading = false;
            if (this.pagesAvailable() > this.currentPage()) {
              this.loadMoreText = SHOWMORE_TEXT;
            }
          }

          this.cd.markForCheck();
        },
        error: (error) => {
          console.error('Error filtering ledgers:', error);
          this.libraryLedgerSets = [];
          this.galleryTypeSvc.clearLibraryLedgerSets();
          this.setMessage('Error filtering ledgers', 'red', true);
          this.cd.markForCheck();
        }
      });
    
    this.subscriptionList.push(subscription);
    return subscription;
  }


  getThumbnailType(img: ImageFile): ThumbnailType {
    if (img.hasBoundPages && !img.isBoundInnerPage) {
      if (img.typeOfImageId == environment.typeOfImageIds['Letters & Diaries'])
      {
        return ThumbnailType.BOUND_SET;
      } else {
        return ThumbnailType.IMAGE_SET;
      } 
    }
    return ThumbnailType.REGULAR;
  }

  handleLedgerSetSelection(event: RelatedImageSetViewDataModel) {
    console.log('Ledger set selected:', event);
    
    // Simply navigate to the first image (thumbnailImage) in single view
    if (event.thumbnailImage && event.thumbnailImage.uid) {
      // Set the context so single image view knows about the ledger
      this.galleryTypeSvc.setLastSelectedRecord(event.thumbnailImage);
      
      // Store ledger info for breadcrumb/navigation
      this.galleryTypeSvc.storeRelatedSetNameFilter(event.name, event.uid);
      this.galleryTypeSvc.storeRelatedSetUIDFilter(event.uid);
      
      // Navigate directly to single image view
      this.router.navigate(['imageSingleView', event.thumbnailImage.uid], {
        queryParams: {
          ledgerSetUID: event.uid,
          ledgerSetName: event.name,
          fromLedgerView: true
        }
      });
    } else {
      console.error('No thumbnail image found for ledger set:', event);
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Error',
          'This ledger set has no images.',
          undefined, undefined, StarbaseNotificationSentiment.Error
        )
      );
    }
  }

  handleRSSelectedThumbnail(event?: RelatedImageSetViewDataModel) {
    this.currentSort = 4;
    this.setMessage(LOADING_MESSAGE);
    this.selectedRelatedSetName = event.name;
    this.selectedRelatedSetUID = event.uid;

    this.currentFilters = this.galleryTypeSvc.getCurrentLibraryFilters();
    const galleryType = this.galleryTypeSvc.getGalleryType();

    if (galleryType.uid && galleryType.uid > 0 && galleryType.typeOfImage !== 'All') {
      this.currentFilters.replaceFilter('TypeOfImageId', galleryType.uid);
    }

    this.currentFilters.replaceFilter('RelatedSetUID', this.selectedRelatedSetUID.toString());
    this.currentFilters.page = 1;
    this.currentFilters.rpp = 35;
    this.currentFilters.sortFields[0] = 'SequenceNumber';
    this.currentFilters.sortAsc = true;

    this.galleryTypeSvc.setCurrentLibraryFilters(this.currentFilters);
    this.galleryTypeSvc.storeRelatedSetNameFilter(event.name, event.uid);

    this.toggleRSV();
    this.applyFilters(this.currentFilters);
  }

  toggleRSV(){
    this.RSVcontainer = !this.RSVcontainer;
  }

  closeRSV() {
    this.RSVcontainer = true;
  }

  togglePPForms() {
    this.showPrePrintedList = !this.showPrePrintedList;
  }

  toggleCivRes() {
    this.showCivResearchList = !this.showCivResearchList;
  }

  // 'Show more...' control
  loadNextPage(): void {
    if (this.loadMoreText === LOADING_MESSAGE) {
      return;
    }

    const cf = this.galleryTypeSvc.getCurrentLibraryFilters(this.rpp);
    if (cf.page < cf.totalPages) {
      cf.page++;
      this.galleryTypeSvc.setLastSelectedRecord(undefined);
      this.galleryTypeSvc.setLastViewedRecordRelatedSetStatus(false);
      this.lastViewedRecord = undefined;
      this.applyFilters(cf, true);
      if (this.batchEditMode) {
        this.resetBatchCollection();
      }
      return;
    }

    console.log('Already at last page.');
  }

  public setMessage(message: string = '', msgColor?: string, retry?: boolean, reset?: boolean) {
    this._message = message;
    this.messageColor = msgColor || 'black';
    this.retry = retry;
    this.reset = reset;
    if (this._message === LOADING_MESSAGE) {
      this.isLoading = true;
    } else {
      this.isLoading = false;
    }

    this.cd.detectChanges();
  }


/*.... Update Sequence Number .... */
  public turnOnUpdateSequenceMode() {

    const confirmFilterModal = new StarbaseModalOptions(
        'Confirm filter replacement',
        `Toggling to update sequence mode will cause you to lose your filters, including your current library type ${this.galleryTypeSvc.getGalleryType().typeOfImage}.`,
        [
          new StarbaseModalButton(
            'No, keep current filters',
            () => {
              this.modalSvc.closeModal('User chose to viewing related album filter');
              return;
          }
          ),
          new StarbaseModalButton(
            'Yes',
            () => {
              this.notiSvc.postNotification(
                this.notiSvc.notificationBuilder(
                  'Please wait',
                  'Loading Related Album data...',
                  undefined, undefined, StarbaseNotificationSentiment.Info));
              this.updateSeqMode = true;
              this.toggleFiltersSection(!this.updateSeqMode);
              this.showRSthumbnails = false;
              this.keepRSThumbnailsHidden = true;

              const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
              cf.sortFields = ['SequenceNumber'];;
              cf.searchPhrase = '';
              cf.sortAsc = true;
              //cf.addToSorts('RelatedImageSet');
              cf.filters = cf.filters.filter( f => f[0] === 'RelatedSetUID');
              // cf.replaceFilter('RelatedImageSet', this.relatedSetNameFilterActiveName);
              
              // if (!cf.filters.some(f => f[0] === 'RelatedSetUID')) {
              //   // If no RelatedSetUID filter exists, we can't proceed
              //   this.notiSvc.postNotification(
              //     this.notiSvc.notificationBuilder(
              //       'Error',
              //       'No related set is currently selected. Please select a related set first.',
              //       undefined, undefined, StarbaseNotificationSentiment.Error));
              //   this.updateSeqMode = false;
              //   this.modalSvc.closeModal('No related set selected');
              //   return;
              // }

              if (this.RISSearchResultsToDisplay.length > 0) { //clear related search results
                this.RISSearchResultsToDisplay = [];
                this.RISSearchResults = [];
              }

              this.galleryTypeSvc.setCurrentLibraryFilters(cf);

              /**
               * Turn off all gallery type, set them to default, gallery goes to all image type in order to update sequence numbers.
               */
              const pageImgType: ImageType = this.defaultImgType;
              this.galleryTypeSvc.CivilianResearchMode = false;
              this.galleryTypeSvc.setPrePrintedMode(false);
              this.galleryTypeSvc.setGalleryType(pageImgType, true);

              if (this.galleryTypeSvc.getGalleryType().uid !== pageImgType.uid) {
                this.galleryTypeSvc.setGalleryType(pageImgType, true);
              }

              this.applyFilters(cf);
              // this.reloadData(this.imageTypeFilter, true);

              // this.getAllImagesForRS(cf);
              this.modalSvc.closeModal('User chose to replace the filters and proceed to update the sequence numbers.');
            }
          )
        ],
        StarbaseModalTypes.Info,
        this.confirmFilterModal
      );
      confirmFilterModal.forcedWidth = this.isHandset ? '90vw' : '';
      this.modalSvc.postModal(confirmFilterModal);
  }


public turnOffUpdateSequenceMode(isCancel?: string) {

  if (isCancel === '1' && this.currentSeqNumbersModified){
    this.modalSvc.postModal(
      new StarbaseModalOptions(
        'Confirmation?',
        'Cancelling now will cause you to lose your changes.',
        [
          new StarbaseModalButton(
            'No, continue editing.',
            () => {
              this.modalSvc.closeModal('User chose to continue editting related album sequence numbers.');
              return;
          }
          ),
          new StarbaseModalButton(
            'Yes',
            () => {
              this.updateSeqMode = false;
              this.showRSthumbnails = true;
              this.keepRSThumbnailsHidden = false;
              this.toggleFiltersSection(true);
              this.currentSeqNumbersModified = false;

              this.modalSvc.closeModal('User chose to discard related album sequence number changes.');

              const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
              cf.searchPhrase = '';
              cf.sortFields = ['SequenceNumber'];
              // cf.addToSorts('RelatedImageSet');
              cf.filters = cf.filters.filter( f => f[0] === 'RelatedSetUID');

              const pageImgType: ImageType = this.defaultImgType;
              this.galleryTypeSvc.setGalleryType(pageImgType, true);

              this.applyFilters(cf);
              this.cd.markForCheck();
            }
          )
        ],
        StarbaseModalTypes.Info,
        this.confirmFilterModal
      )
    );
  } else {

    this.updateSeqMode = false;
    this.showRSthumbnails = true;
    this.keepRSThumbnailsHidden = false;
    this.toggleFiltersSection(true);
    this.currentSeqNumbersModified = false;

    const cf = this.galleryTypeSvc.getCurrentLibraryFilters();
    cf.searchPhrase = '';
    cf.sortFields = ['SequenceNumber'];
    // cf.addToSorts('RelatedImageSet');
    cf.filters = cf.filters.filter( f => f[0] === 'RelatedSetUID');

    const pageImgType: ImageType = this.defaultImgType;
    this.galleryTypeSvc.setGalleryType(pageImgType, true);

    // this.getAllImagesForRS(cf);
    this.applyFilters(cf);
    this.cd.markForCheck();
  }

}

  /*
  Fired when user clicks the save update button;
  Resets the updateSeq mode in case of success, in case of error resets the pending changes to sequence numbers as well.
  */
  public saveRSSeq() {
    //TODO: UPDATE TO UID

    const setName = this.relatedSetNameFilterActiveName;
    const setUID = this.relatedSetNameFilterActiveUID;

    this.modalSvc.postModal(
      new StarbaseModalOptions(
        'Confirmation?',
        `Please confirm if you would like to update the sequence numbers for the "${setName}" related album?`,
        [
          new StarbaseModalButton(
            'Yes',
            () => {
              this.isSavingUpdatedSequence = true;

              let toPassArray = [];
              toPassArray = this.libImages.map(i => i.uid);
              let rsTuple: [string, number] = [setName, setUID];

              const temp = this.imgSvc.updateRelatedSetSequenceNumber(toPassArray, rsTuple).pipe(
                share(),
                finalize(() => this.isSavingUpdatedSequence = false)
              );
              const notify = this.notiSvc.notificationBuilderAsync(
                'Please Wait',
                'Saving the updated sequence may take a moment.',
                null,
                temp,
                null,
                StarbaseNotificationSentiment.Notice,
              );

              this.notiSvc.postNotification(notify);
              temp.subscribe(() => {
                this.currentSeqNumbersModified = false;
                this.turnOffUpdateSequenceMode('0');
                this.currentSort = 4;
              },
              (e) => {
                notify.content = 'Failed to update the sequence numbers.';
                this.turnOffUpdateSequenceMode('0'); //reset the libimages to original sequence.
              });
              this.modalSvc.closeModal('Closed by the user');
            }),
            new StarbaseModalButton(
             'No',
            () => {
              this.modalSvc.closeModal('Closed by the user.');
            })
          ],
          StarbaseModalTypes.Info,
      )
    );
  }

  /*
  Expects prev and new sequence numbers; coming from thumbnail component
  */
  public updateSeqNo(data) {
    let newIndex = data[0] - 1;
    const prevIndex = data[1] - 1;

    // If newIndex out of bound, set it to correct index.
    if (newIndex < 0) {
      newIndex = 0;
    }
    if (newIndex > this.libImages.length - 1) {
      newIndex = this.libImages.length - 1;
    }

    const [removedImage] = this.libImages.splice(prevIndex, 1); // Remove the image at previous index.
    this.libImages.splice(newIndex, 0, removedImage); // Move it to the new index.

    // eslint-disable-next-line eqeqeq
    if (prevIndex != newIndex){
      this.currentSeqNumbersModified = true;
    }
  }

/* ....Batch Edit Section.... */

  /** Toggle between Batch/Image Selection Mode on the gallery.
   *
   * @param refreshData Defaults to false. If true, and the toggle
   * of batchEditMode will be false, then this will force a reload of data from the server. */
  public toggleBatchEditMode(refreshData: boolean = false): void {
    this.resetBatchCollection();
    this.toggleFiltersSection(this.batchEditMode);
    this.closeRSV();
    this.batchEditMode = !this.batchEditMode;
    if (!this.batchEditMode) {
      this.selectionMode = false;
      this.selection.clear();
      this.lastSelectedImage = null;
      
      if (this.lassoDirective) {
        this.lassoDirective.clearSelection();
      }
      
      if (refreshData === true) {
        this.reloadData(this.imageTypeFilter, true);
      }
    } else {
      this.selectionMode = true;
    }
    
    this.cd.detectChanges();
  }
  /** Called by the Drag-To-Select plugin when drag event is done.
   *
   * @param selectedItems The ImageFile array that was "dragged over" to select them
   */
  public dragSelectThumbnails(selectedItems: ImageFile[]): void {
    //selecting image should only work on thumbnails that are not in relatedImageSetViewmode.
    const nonRSVthumbnails = this.thumbnails.filter(th => !th.isRelatedImageSetViewMode);
    for (const t of nonRSVthumbnails) {
      t.selected = false;
      t.sequenceNumber = 0;
      t.changeDetection();
    }
    for (let i = 0; i < selectedItems.length; i++) {
      const t = nonRSVthumbnails.find(a => a.imageData.uid === selectedItems[i].uid);
      t.selected = !t.selected;
      t.sequenceNumber = i + 1; // set the gathered sequence number for displaying on the thumbnail
    }
    this.batchEditImages = [...new Set(this.batchEditImages)]; // ensure no duplicates
    this.cd.detectChanges();
  }

  /** Toggles selecting or unselecting all images loaded in the gallery view
   * (through the local libImages var).
   */
  public batchEditSelectAll(): void {
    if (this.batchEditImages.length > 0) {
      // Something is selected - deselect all
      this.selection.clear();
      this.batchEditImages = [];
      this.lastSelectedImage = null;
    } else {
      // Nothing is selected - select all
      this.selection.clear();
      this.batchEditImages = [];
      this.libImages.forEach(img => {
        this.selection.select(img);
        this.batchEditImages.push(img);
      });
      
      // Set last selected to the last item
      if (this.libImages.length > 0) {
        this.lastSelectedImage = this.libImages[this.libImages.length - 1];
      }
    }
    
    this.updateThumbnailSequences();
    this.cd.detectChanges();
  }

  
  public openBatchEditBox(): void {
     // this on purpose to temporarily disable the below lines until Batch Edit is turned back on
    this.showBatchEditBox = true;
    this.selectionMode = false;
    return;
    this.notiSvc.postNotification(this.notiSvc.notificationBuilder(
      'Batch Edit disabled',
      'Sorry, the Batch Edit system is not ready yet.'
    ));
  }

  public closeBatchEditBox(): void {
    this.showBatchEditBox = false;
    this.selectionMode = false;
    return;
  }

  public cancelBatchEdit(): void {
    this.selectionMode = true;
  }

  public batchEditReload(): void {
    this.showBatchEditBox = false;
    this.selectionMode = true;
    this.resetBatchCollection();
    this.reloadData(this.libImages[0].typeOfImage, true);
  }

  public batchEditConfirmed(edit: BatchEdit): void {
    if (!this.isSaving) {
      this.isSaving = true;
      const batchedit$ = this.imgSvc.batchEditImageRecordsOnServer(edit).pipe(share());
      const notifier = new StarbaseNotificationObject(
        'Saving...',
        null,
        StarbaseNotificationSentiment.Notice,
        null,
        batchedit$);
      batchedit$.subscribe(
        {
          next: () => {
            this.notiSvc.postNotification(new StarbaseNotificationObject('Batch Edit Successful', edit.imageModelUIDs.length + ' Image Records Edited', StarbaseNotificationSentiment.Success, 5000));
            this.showBatchEditBox = false;
            this.resetBatchCollection();
            this.toggleFiltersSection(this.batchEditMode);
            this.batchEditMode = !this.batchEditMode;
            this.isSaving = false;
            notifier.updateTitle('Success');
            notifier.updateContent('Batch Edit Successfully Applied');
          },
          error: (error) => {
            this.notiSvc.postNotification(new StarbaseNotificationObject('Batch Edit Failed', 'Failed to Edit ' + edit.imageModelUIDs.length + ' Records', StarbaseNotificationSentiment.Error, 5000));
            console.error(error);
            this.isSaving = false;
            notifier.updateTitle('Error');
            notifier.updateContent('Failed to Apply batch Edit');
          }
        });
      this.notiSvc.postNotification(notifier);
    }
  }

/* ....End Batch Edit Section.... */


/* .... Bound Image Sets Section.... */
  /** Opens the modal for binding images after thumbnail selections are made. */
  startBindingImages(): void {
    let index = 0;
    this.createBoundSetModal = new StarbaseModalOptions(
      'Create Bound Images Set',
      ``,
      [], StarbaseModalTypes.Notice, this.bindImageSetsModal);
    let imagesBound = 0;
    let errors = false;
    let iterations: BoundImageSet[] = [];
    const updateBindingImagesContent$ = new Subject<string>();
    const updateBindingImagesTitle$ = new Subject<string>();

    this.createBoundSetModal.buttons = [
      new StarbaseModalButton('Okay', () => {
        if (this.tempBoundSetName === '') {
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Set Name Required',
              'Please enter a name before continuing.',
              undefined, 4750, StarbaseNotificationSentiment.Warning));
          return;
        }
        this.createBoundSetModal.working = true;
        iterations = [];
        for (const ir of this.batchEditImages) {
          const bis = new BoundImageSet(this.tempBoundSetName, ir, index++);
          iterations.push(bis);
        }
        imagesBound = 0;
        errors = false;
        const bindingImagesAsync$ = from(iterations)
          .pipe(
            mergeMap((x: BoundImageSet) => {
              updateBindingImagesContent$.next('Completed ' + (imagesBound++) + ' of ' + this.batchEditImages.length);
              return this.lookupSvc.saveNewBoundImageSetToServer(x).pipe(delay(250));
            }, 1),
            catchError(e => {
              console.error(e);
              errors = true;
              updateBindingImagesContent$.next(
                'Error when creating the set while adding selection #' + imagesBound + ' to the set. The set may be partially created.');
              return throwError(e);
            }),
            finalize(() => {
              if (!errors) {
                updateBindingImagesTitle$.next('Bound Set Created');
                updateBindingImagesContent$.next(
                  `Successfully created set, "${this.tempBoundSetName}," on the server with ${imagesBound} pages.`);
                this.createBoundSetModal.working = false;
                this.tempBoundSetName = '';
                this.modalSvc.closeModal('User pressed Okay. Process was successful.');
                this.addingToBoundSetMode = false;
                this.toggleBatchEditMode(true);
              } else {
                updateBindingImagesTitle$.next('Bound Set Failed');
                updateBindingImagesContent$.next(
                  'Error when creating the set while adding selection #' + imagesBound + ' to the set. The set may be partially created.');
                this.createBoundSetModal.working = false;
                imagesBound = 0;
                this.tempBoundSetName = '';
              }
            })
        ); // concurrent max 1 to prevent Http 429.

        const bindingNotifyAsync = new StarbaseNotificationObject('Binding images...',
          'Completed 0 of ' + this.batchEditImages.length,
          StarbaseNotificationSentiment.Info,
          undefined,
          bindingImagesAsync$,
          true
        );
        bindingNotifyAsync.updateContentAsync(updateBindingImagesContent$);
        bindingNotifyAsync.updateTitleAsync(updateBindingImagesTitle$);
        this.notiSvc.postNotification(bindingNotifyAsync);
      }),
      new StarbaseModalButton('Cancel', () => {
        this.modalSvc.closeModal('User pressed Cancel.');
      })
    ];

    // find how many bound sets were selected in this batch edit session
    const boundSetsPresentCount = this.batchEditImages.filter(a => a.hasBoundPages);
    if (boundSetsPresentCount.length > 1) { // do not allow binding an existing bound set to other ones
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Image Binding Error',
          'You cannot bind multiple Bound Sets to each other.',
          undefined, undefined, StarbaseNotificationSentiment.Error));
      return;
    }

    const boundSetsPresent = this.batchEditImages.findIndex(a => a.hasBoundPages);
    if (boundSetsPresent !== -1) {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Please wait',
          'Loading Bound Set data...',
          undefined, undefined, StarbaseNotificationSentiment.Info));
      this.addingToBoundSetMode = true;
      this.boundImageSetSubscription = this.lookupSvc.getBoundImageSetByImage(this.batchEditImages[boundSetsPresent].uid).subscribe(b => {
        index = b.reduce((p, c) => (p.sequenceNumber > c.sequenceNumber) ?
          p
          : c,
          new BoundImageSet(
            '',
            this.batchEditImages[0], 0)).sequenceNumber;
             /* ^ Start numbering the appended images as the next number in the sequence
             * after whichever sequence number is the highest in the existing bound set. */
        console.log(index);
        // move the existing set to the beginning of the batchEdit array, so it is shown as the "cover."
        this.batchEditImages.unshift(this.batchEditImages.splice(boundSetsPresent, 1)[0]);
        this.tempBoundSetName = this.batchEditImages[0].boundSetName;
        this.modalSvc.postModal(this.createBoundSetModal);
      }, e => {
        console.error(e);
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Server communication error',
            'Something went wrong when trying to load Bound Set data from the server.',
            undefined, undefined, StarbaseNotificationSentiment.Error));
      });
      this.subscriptionList.push(this.boundImageSetSubscription);
    } else {
      this.addingToBoundSetMode = false;
      this.modalSvc.postModal(this.createBoundSetModal);
    }
  }
/* ....End Bound Image Sets Section.... */
// ---------------------------------------
/* ....Related Image Sets Section.... */

  /** After thumbnail selections are made,
   * this function opens the modal for configuring a related image set and finishing the process of creating the set. */
  startRelatingImages(): void {
    // Check if we have images selected
    if (!this.batchEditImages || this.batchEditImages.length < 2) {
      this.notiSvc.postNotification(
        this.notiSvc.notificationBuilder(
          'Selection Required',
          'Please select at least 2 images to relate.',
          null, 
          5000, 
          StarbaseNotificationSentiment.Warning
        )
      );
      return;
    }
    this.notiSvc.postNotification(
      this.notiSvc.notificationBuilder(
        'Please wait',
        'Loading Related Set data...',
        null,
        2000,
        StarbaseNotificationSentiment.Info
      )
    );

    // Reset all modal fields
    this.relatedSetDescription = '';
    this.relatedSetType = RelatedSetTypeEnum.GENERAL;
    this.isOrdnanceReturnSet = false;
    this.relatedSetsSearcherOutput = '';
    this.relatedSetsSearcherOutputUID = null;
    this.selectedImageSetUIDDropdown = null;
    this.relatedImageSetsForBatch = [];
    
    // Reset FormControl
    this.relatedSetControl.setValue('');
    this.relatedSetControl.enable();
  
    // Initialize the filtered observable
    this.filteredRelatedSets = this.relatedSetControl.valueChanges.pipe(
      startWith(''),
      map(value => this._filterRelatedSets(value || ''))
    );
    this.createImageSetModal = new StarbaseModalOptions(
      'Relate Images',
      ''
    );
  
  this.createImageSetModal.bodyTemplateRef = this.relateImageSetsModal; 
  this.createImageSetModal.forcedWidth = '625px';
  
  this.createImageSetModal.buttons = [
    new StarbaseModalButton('Save', () => {
      const setUID = this.selectedImageSetUIDDropdown || this.relatedSetsSearcherOutputUID;
      const setName = this.relatedSetControl.value || this.relatedSetsSearcherOutput;

      if (!setUID && (!setName || setName.trim() === '')) {
        this.notiSvc.postNotification(
          this.notiSvc.notificationBuilder(
            'Set Name Required',
            'Please enter a name for the new set or select an existing set.',
            null, 
            5000, 
            StarbaseNotificationSentiment.Warning
          )
        );
        return;
      }

      if (!setUID && setName) {
          const existingSet = this.allRelatedSets.find(
          rs => rs.name.toLowerCase() === setName.trim().toLowerCase()
        );
        
        if (existingSet) {
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Set Already Exists',
              `A set named "${setName}" already exists. Adding selected images to the existing set.`,
              null,
              3000,
              StarbaseNotificationSentiment.Info
            )
          );
          
          this.relatedSetsSearcherOutputUID = existingSet.uid;
        }
      }

      this.createImageSetModal.working = true;
      // Batch payload
      const batchPayload = {
        setUID: this.relatedSetsSearcherOutputUID || setUID || null,
        setName: setName,
        description: this.relatedSetDescription,
        setType: this.relatedSetType,
        isOrdnanceReturnSet: this.isOrdnanceReturnSet,
        imageUIDs: this.batchEditImages.map(img => img.uid)
      };

      this.lookupSvc.processBatchRelatedSet(batchPayload).subscribe(
        response => {
          //console.log('Batch processing successful:', response);
          
          // Refresh the related sets
          this.lookupSvc.getAllRelatedSets().subscribe(
            allSets => {
              this.allRelatedSets = allSets || [];
              //console.log('Refreshed related sets after save:', this.allRelatedSets.length);
              
              // Update the filtered observables
              this.filteredRelatedSets = this.relatedSetControl.valueChanges.pipe(
                startWith(''),
                map(value => this._filterRelatedSets(value || ''))
              );
              
              this.cd.markForCheck();
            },
            error => {
              console.error('Error refreshing related sets:', error);
            }
          );
          
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Success',
              `Related ${this.batchEditImages.length} images to set "${setName}"`,
              null, 
              5000, 
              StarbaseNotificationSentiment.Success
            )
          );
          
          this.modalSvc.closeModal('Success');
          this.resetBatchCollection();
          
          // Refresh
          if (this.relatedSetUIDFilterActiveBool) {
            this.reloadData(this.imageTypeFilter, true);
          }
        },
        error => {
          console.error('Batch processing failed:', error);
          
          this.notiSvc.postNotification(
            this.notiSvc.notificationBuilder(
              'Operation Failed',
              error.error?.message || 'Failed to process related set batch. Please try again.',
              null, 
              5000, 
              StarbaseNotificationSentiment.Error
            )
          );
          if (this.createImageSetModal) {
            this.createImageSetModal.working = false;
            }
        }
      );
    }),
    new StarbaseModalButton('Cancel', () => {
      this.relatedSetsSearcherOutput = '';
      this.relatedSetsSearcherOutputUID = null;
      this.modalSvc.closeModal('User cancelled');
      this.resetBatchCollection();
    })
  ];

  const imageIds: number[] = this.batchEditImages.map(i => i.uid);

  if (this.allRelatedSets.length === 0) {
    // Load all related sets
    this.lookupSvc.getAllRelatedSets().subscribe(
      allSets => {
        this.allRelatedSets = allSets || [];
        
        // Update the filtered list after data loads
        this.filteredRelatedSets = this.relatedSetControl.valueChanges.pipe(
          startWith(''),
          map(value => this._filterRelatedSets(value || ''))
        );
        
        this.cd.markForCheck();
      },
      error => {
        this.allRelatedSets = [];
      }
    );
  }

  // Load existing sets for selected images
  if (imageIds.length > 0) {
    this.lookupSvc.getExistingRelatedImageSetsForMultipleImages(imageIds).subscribe(
      existingSets => {
        this.notiSvc.setCurrentlyNotifying(false);
        
        this.relatedImageSetsForBatch = existingSets || [];
        console.log('Existing sets for batch:', this.relatedImageSetsForBatch.length);
        
        this.modalSvc.postModal(this.createImageSetModal);
        this.cd.markForCheck();
      },
      error => {
        console.error('Error loading existing sets:', error);
        
        this.notiSvc.setCurrentlyNotifying(false);
        this.relatedImageSetsForBatch = [];
        this.modalSvc.postModal(this.createImageSetModal);
        this.cd.markForCheck();
      }
    );
  } else {
    this.notiSvc.setCurrentlyNotifying(false);
    this.modalSvc.postModal(this.createImageSetModal);
    this.cd.markForCheck();
  }
}

  onRelatedSetSelected(setName: string): void {
    const selectedSet = this.allRelatedSets.find(s => s.name === setName);
    if (selectedSet) {
      this.relatedSetsSearcherOutput = selectedSet.name;
      this.relatedSetsSearcherOutputUID = selectedSet.uid;
      this.selectedImageSetUIDDropdown = null; // Clear dropdown selection
      this.cd.markForCheck();
    }
  }
/* ....End Related Image Sets Section.... */

  /** Toggles the filter/search bar between hide and show states.
   *
   * @param override Optional. Force the state to show (true) or hide (false).
   */
  toggleFiltersSection(override?: boolean) {
    this.showFilters = override == null ? !this.showFilters : override;
    if (!this.showFilters) {
      setTimeout(() => {
        // Check if selectionComponent exists before calling update
        if (this.selectionComponent) {
          this.selectionComponent.update();
        }
      }, STAGGER_ANIM_TIME + 1); // wait for animation to complete
    }
  }

/* .... DISPLAY MODES .... */
  condensedMode() {
    this.galleryTypeSvc.setViewMode('condensedMode');
    this.thumbnailGridMode = libraryViewModes.condensedMode;
    this.scrollToLastViewedThumbnail();
    setTimeout(() => {
      if (this.selectionComponent) {
        this.selectionComponent.update();
      }
    }, STAGGER_ANIM_TIME + 1);
  }

  gridLargeMode() {
    this.galleryTypeSvc.setViewMode('gridLargeMode');
    this.thumbnailGridMode = libraryViewModes.gridLargeMode;
    this.scrollToLastViewedThumbnail();
    setTimeout(() => {
      if (this.selectionComponent) {
        this.selectionComponent.update();
      }
    }, STAGGER_ANIM_TIME + 1);
  }

  gridSummaryMode() {
    this.galleryTypeSvc.setViewMode('gridSummaryMode');
    this.thumbnailGridMode = libraryViewModes.summaryMode;
    this.scrollToLastViewedThumbnail();
    setTimeout(() => {
      if (this.selectionComponent) {
        this.selectionComponent.update();
      }
    }, STAGGER_ANIM_TIME + 1);
  }

  listMode() {
    this.galleryTypeSvc.setViewMode('listMode');
    this.thumbnailGridMode = libraryViewModes.listMode;
    this.scrollToLastViewedThumbnail();
    setTimeout(() => {
      if (this.selectionComponent) {
        this.selectionComponent.update();
      }
    }, STAGGER_ANIM_TIME + 1);
  }

  private initSetViewMode() {
    const viewMode = this.galleryTypeSvc.getViewMode(); // get view mode of the gallery from the service
    this.setViewMode(viewMode); // Determines whether the view mode is set to small, info, or list mode
  }

  //  Creates otherLibCounts array for civilian research library, if mainintainLibrary is true - the library was reloaded,
  //  else it sets up a new array to for civilian research library to load in default mode.
  private setOtherLibCounts(): void {
    if (this.maintainLibrary){
      this.applyCRfilters(this.galleryTypeSvc.getCurrentLibraryFilters(null, true));
    // eslint-disable-next-line eqeqeq
    } else if (this.civilianMode == true) {
      this.imgSvc.civilianRecordsInfo(true).subscribe(civResearchRecordsInfo => {
        this.otherLibCounts = [];
        const typeMap = new Map(this.allImageTypesVirtual.map(type => [type.val, type]));

        for (const iterable of civResearchRecordsInfo) {
          const type = typeMap.get(iterable.typeOfImageId);

          if (type) {
            this.otherLibCounts.push({
              val: type.val,
              txt: type.txt,
              count: iterable.count,
              selected: true
            });
          }
        }
      });
    } else if ( this.pagesAvailable() <= this.currentPage()) {
      this.imgSvc.getOtherLibCounts(this.galleryTypeSvc.getCurrentLibraryFilters(), false).subscribe(civResearchRecordsInfo => {
        this.otherLibCounts = [];
        const typeMap = new Map(this.allImageTypesVirtual.map(type => [type.val, type]));

        for (const iterable of civResearchRecordsInfo.collection) {
          const type = typeMap.get(iterable.typeOfImageId);

          if (type) {
            this.otherLibCounts.push({
              val: type.val,
              txt: type.txt,
              count: iterable.count,
              selected: true
            });
          }
        }

        this.cd.markForCheck();
      });
    }
  }
  private reportFilters(fp: FilterParams<ImageFile>) {
    this.appInsightsSvc.logEvent('Gallery filters applied', {
      filters: fp.filters ? fp.filters.toString() : '',
      orClusterFilters: fp.orClusterFilters ? fp.orClusterFilters.toString() : '',
      searchString: fp.searchPhrase,
      sortCols: fp.sortFields ? fp.sortFields.toString() : '',
      page: fp.page.toString(),
      rpp: fp.rpp.toString()
    });
    console.log('logging filters to Az AI');
  }

  isImageSelected(img: ImageFile): boolean {
    return this.selection.isSelected(img);
  }

  onLassoSelection(event: LassoSelectionEvent) {
    if (!this.batchEditMode) return;
    
    // Handle removed items first
    if (event.removed.length > 0) {
      // Clear entire selection when lasso replaces selection
      this.selection.clear();
      this.batchEditImages = [];
      this.lastSelectedImage = null;
    }
    
    // Add new items
    event.added.forEach((el: HTMLElement) => {
      const uid = el.getAttribute('data-image-uid');
      if (uid) {
        const img = this.libImages.find(i => i.uid === +uid);
        if (img && !this.selection.isSelected(img)) {
          this.selection.select(img);
          this.batchEditImages.push(img);
          
          // Update last selected for lasso
          if (this.batchEditImages.length === 1) {
            this.lastSelectedImage = img;
          }
        }
      }
    });
    
    this.batchEditImages = this.batchEditImages.filter((img, i, x) => {
      return i === x.findIndex(y => y.uid === img.uid);
    });
    
    // Update thumbnail sequences after all changes
    this.updateThumbnailSequences();
    this.cd.detectChanges();
  }

  getSelectionSequenceNumber(img: ImageFile): number {
    const index = this.batchEditImages.findIndex(i => i.uid === img.uid);
    return index > -1 ? index + 1 : 0;
  }

  /** Unselect all selected for this batch session. */
  // private resetBatchCollection(): void {
  //   this.selection.clear();
  //   this.batchEditImages = [];
  //   this.lastSelectedImage = null;
    
  //   if (this.lassoDirective) {
  //     this.lassoDirective.clearSelection();
  //   }
    
  //   this.cd.detectChanges();
  // }
  private resetBatchCollection(): void {
    this.batchEditImages = [];
    this.selection.clear();
    this.lastSelectedImage = null;
    
    // Clear related set fields
    this.relatedSetsSearcherOutput = '';
    this.relatedSetsSearcherOutputUID = null;
    this.selectedImageSetUIDDropdown = null;
    this.relatedSetDescription = '';
    this.relatedSetType = RelatedSetTypeEnum.GENERAL;
    this.isOrdnanceReturnSet = false;
    
    // Reset the FormControl
    if (this.relatedSetControl) {
      this.relatedSetControl.setValue('');
      this.relatedSetControl.enable();
    }

    // Clear modal reference
    this.createImageSetModal = null;
    
    if (this.lassoDirective) {
      this.lassoDirective.clearSelection();
    }
    this.cd.markForCheck();
  }
}